module.exports = __webpack_public_path__ + "img/投标保函.77e11398.png";